{
  "name": "ama-plan-frontend",
  "version": "1.1.170-dev",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --configuration dev",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test",
    "test-coverage": "ng test --code-coverage",
    "test-headless": "ng test --watch=false --browsers=ChromeHeadless --reporters=junit --code-coverage",
    "postinstall": "cd node_modules/tramlib && npm run build"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.18",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.18",
    "@angular/compiler": "21.2.18",
    "@angular/core": "21.2.18",
    "@angular/forms": "21.2.18",
    "@angular/google-maps": "21.2.14",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.18",
    "@angular/platform-browser-dynamic": "21.2.18",
    "@angular/router": "21.2.18",
    "@mapbox/shp-write": "^0.4.3",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@shortercode/webzip": "^1.1.1-0",
    "@types/google.maps": "^3.64.0",
    "@types/shpjs": "^3.4.7",
    "angular-auth-oidc-client": "^21.0.1",
    "buffer": "^6.0.3",
    "crypto-es": "^3.1.3",
    "immer": "^10.2.0",
    "isoxml": "^1.11.2",
    "rxjs": "~7.8.1",
    "shpjs": "^4.0.4",
    "spherical-geometry-js": "^3.0.2",
    "tramlib": "1.7.0",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "21.2.19",
    "@angular/cli": "21.2.19",
    "@angular/compiler-cli": "21.2.18",
    "@angular/localize": "21.2.18",
    "@ngrx/eslint-plugin": "^21.1.0",
    "@ngx-env/builder": "^21.0.1",
    "@types/jasmine": "^6.0.0",
    "@typescript-eslint/eslint-plugin": "^8.59.0",
    "@typescript-eslint/parser": "^8.59.0",
    "angular-eslint": "^21.3.1",
    "eslint": "^9.39.4",
    "jasmine-core": "~5.1.1",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "typescript": "5.9.3"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "esbuild@0.27.3": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.3": true
  }
}
